export { ActiveWidget } from './classes/active-widget';
export { ActiveDashboard } from './classes/active-dashboard';
export { ListWidgetOptions } from './interfaces/list-widget-options.interface';
export { ListWidgetComponent } from './components/list-widget/list-widget.component';
export { DashboardModel } from './models/dashboard.model';
export { WidgetModel } from './models/widget.model';
export { WidgetInterface } from './interfaces/widget.interface';
export { CustomWidgetInterface } from './interfaces/custom-widget.interface';
export { CustomWidgetComponent } from './components/custom-widget/custom-widget.component'
export { StreamWidgetInterface } from './interfaces/stream-widget.interface';
export { ActivityStreamWidgetComponent } from './components/activity-stream-widget/activity-stream-widget.component'
export { ChassisDashboardsModule } from './dashboards.module';
export { WidgetListModal } from './modals/widget-list-modal/widget-list.modal';
export { AddWidgetModal } from './modals/add-widget-modal/add-widget.modal';
export { WidgetService } from './services/widget.service';
export { WidgetFactoryService } from './services/widget-factory.service';
export { DashboardService } from './services/dashboard.service';
export { ContainerComponent } from './components/container/container.component';
export { DashboardComponent } from './components/dashboard/dashboard.component';
export { TwoColumnLayoutComponent } from './components/two-column-layout/two-column-layout.component';


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/index.ts